import { AutoComplete, Flex, Select, Space } from 'hljd'
import debounce from 'lodash/debounce'
import React, { Component } from 'react'
import CheckInput from '../CheckInput'

const { Option } = AutoComplete

class WeddingPlace extends Component {
  onHotelChange = async value => {
    const {
      hotels,
      setFieldsValue,
      onChange,
      onSearchHotelBallroom,
      clearHotelBallroom
    } = this.props
    const hotel = hotels.find(item => item.name == value)
    clearHotelBallroom()
    onChange && onChange(value)
    await onSearchHotelBallroom(hotel?.merchantId)
    // 因为onSearchHotelBallroom 为异步请求
    // 然而validate验证通过onChange触发，导致validate中获取hotelBallroom列表长度非实时
    // 因此等因为onSearchHotelBallroom 请求完再触发一次onChange，从而再次触发验证
    // 后期需要调整替换该组件
    onChange && onChange(value)
    if (hotel) {
      setFieldsValue({
        hotel_hall_id: undefined,
        hotel_id: hotel.merchantId
      })
    } else {
      setFieldsValue({
        hotel_hall_id: undefined,
        hotel_id: ''
      })
    }
  }

  onHallChange = e => {
    const { setFieldsValue, onChange, value } = this.props
    setFieldsValue({
      hotel_hall_id: e
    })
    // onChange 触发数据校验
    onChange && onChange(value)
  }

  onDebounceSearch = debounce(val => {
    this.props.onSearchHotel(val)
  }, 300)

  render() {
    const {
      hotels,
      getFieldError,
      value,
      getFieldValue,
      getFieldDecorator,
      hotelBallroom,
      defaultHallId,
      defaultHotelId,
      disabled,
      onClick,
      placeholder
    } = this.props
    getFieldDecorator('hotel_id', {
      initialValue: defaultHotelId || ''
    })
    const hotelId = getFieldValue('hotel_id')

    const options = hotels.map(({ name, city, areaName }) => {
      return (
        <Option key={name} value={name}>
          <Flex sp>
            <span>{name}</span>
            <span>
              {city}，{areaName}
            </span>
          </Flex>
        </Option>
      )
    })
    return (
      <>
        <Space>
          <CheckInput
            onClick={onClick}
            disabled={disabled}
            autoComplete
            allowClear
            value={value}
            placeholder={placeholder}
            dataSource={options}
            style={{ width: 380 }}
            onSearch={this.onDebounceSearch}
            onChange={this.onHotelChange}
            getFieldError={getFieldError}
            optionLabelProp="value"
          />
          {getFieldDecorator('hotel_hall_id', {
            initialValue: defaultHallId
          })(
            <Select
              optionFilterProp="label"
              onChange={this.onHallChange}
              style={{
                width: 280,
                display:
                  hotelId && !!hotelBallroom.length ? 'inline-block' : 'none'
              }}
              placeholder="请选择宴会厅"
              allowClear
              showSearch
              optionLabelProp="label"
            >
              {hotelBallroom?.map(item => (
                <Select.Option key={item.id} label={item.name} value={item.id}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}
                  >
                    <span className="text-cut" style={{ flex: 1 }}>
                      {item.name}
                    </span>
                    <span style={{ flex: '0 0 auto', minWidth: 50 }}>
                      最多{item.max_table_num}桌
                    </span>
                  </div>
                </Select.Option>
              ))}
              <Select.Option label="不关联" value={0}>
                不关联
              </Select.Option>
            </Select>
          )}
        </Space>
        <p style={{ color: '#666' }}>
          关联酒店宴会厅后，您的案例将会在酒店的宴会厅中展示
        </p>
      </>
    )
  }
}

export default WeddingPlace
